<template>
  <div id="headers">
    <MainHeader v-show="show_main_header" />
    <WorldHeader v-show="show_world_header" />
    <JapanHeader v-show="show_japan_header" />
  </div>
</template>

<script>
import MainHeader from "../components/MainHeaderView.vue"
import WorldHeader from "../components/WorldHeaderView.vue"
import JapanHeader from "../components/JapanHeaderView.vue"

/**
 * ヘッダ部
 * 
 * @vue-data {Boolean} [show_main_header] メインヘッダーコンポーネントの表示フラグ
 * @vue-data {Boolean} [show_world_header] 世界編ヘッダーコンポーネントの表示フラグ
 * @vue-data {Boolean} [show_japan_header] 日本編ヘッダーコンポーネントの表示フラグ
 * @vue-computed {String} currentGame 表示中のView
 */

export default {
  name: "HeaderView",

  components: {
    MainHeader,
    WorldHeader,
    JapanHeader
  },

  data () {
    return {
      show_main_header: false,
      show_world_header: false,
      show_japan_header: false
    }
  },

  computed: {
    currentGame () {
      return this.$store.getters.currentGame
    }
  },

  created () {
    this.switchHeader()
  },

  watch: {
    currentGame () {
      this.switchHeader()
    }
  },

  methods: {
    /**
     * 表示中のViewに応じてヘッダーコンポーネントを切り替える
     */
    switchHeader () {
      if (this.currentGame === "Home") {
        this.show_main_header = true
        this.show_world_header = false
        this.show_japan_header = false
      } else if (this.currentGame.match(/World/i)) {
        this.show_main_header = false
        this.show_world_header = true
        this.show_japan_header = false
      } else if (this.currentGame.match(/Japan/i)) {
        this.show_main_header = false
        this.show_world_header = false
        this.show_japan_header = true
      }
    }
  }
}
</script>

<style lang="sass" src='../assets/common_style.sass'></style>
<style lang="sass" scoped>

#app
  -webkit-font-smoothing: antialiased
  -moz-osx-font-smoothing: grayscale
  text-align: center
  color: #29292A
  height: 56px

#how_to_btn
  font-size: 12px
  font-weight: 800
  color: #2E446D
  background: #feffff
  padding: 4px
  width: 50px
  border-radius: 4px

.bg-info 
  background-color: #2E446D !important

img
  max-width: 240px

span
  margin-left: 8px
</style>
